import { gql } from "@apollo/client";

export const GET_DSP_ADJUST_BILL_TASK = gql`
  query GetDspAdjustBillTask($billId: ID!) {
    getDspAdjustBillTask(billId: $billId) {
      id
      billId
      successCount
      failCount
      progress
      createdAt
      finishedTime
      status
      processingStep
      errorMsg
    }
  }
`;

export interface DspAdjustBillTask {
  id: number;
  billId: number;
  successCount: number;
  failCount: number;
  progress: string | null;
  createdAt: string | null;
  finishedTime: string | null;
  /** 0=PENDING 1=PROCESSING 2=COMPLETED 3=FAILED 4=REVERSED */
  status: number;
  processingStep: number;
  errorMsg: string | null;
}

export interface GetDspAdjustBillTaskData {
  getDspAdjustBillTask: DspAdjustBillTask | null;
}

export interface GetDspAdjustBillTaskVariables {
  billId: string;
}
